import React from 'react';
import Appbar from 'components/appbar/Appbar';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import PatientListTable from './list/table/PatientListTable';
import PatientListModule from './list/module/PatientListModule';
import PatientActions from './PatientAction';
import PaginationProvider from 'hooks/pagination';
import Pagination from 'components/pagination/Pagination';
import PatientFilterBox from './PatientFilterBox';
import { useFetchPatients } from './hooks/useFetchPatients';
import { useDisplayMode } from 'hooks/useDisplayMode';
import NoData from 'components/no-data/NoData';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';

const Patient: React.FC = () => {
  const {
    patients,
    filter,
    loading,
    orderedIndex,
    handleSearch,
    handleSort,
    handleChange,
    searched,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchPatients();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Pacientes" ActionsComponent={<PatientActions />} />
      <PageHeaderActions
        title="Pacientes"
        description="Gestão de pacientes da clínica"
        ActionComponent={<NewRecordButton label="Novo paciente" to="/patients/new" />}
      />

      <PatientFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : !searched ? (
          <NoData message="Busque um paciente pelo nome ou CPF" />
        ) : patients.length === 0 ? (
          <NoData message="Nenhum paciente encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? (
              <PatientListTable patients={patients} />
            ) : (
              <PatientListModule patients={patients} />
            )}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Patient;
